import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";

export default function Header() {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const dispatch = useDispatch();

    useEffect(() => {
        const handleClick = (e) => {
            if (!dropdownRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    return (
        <div className="flex justify-between items-center bg-white shadow-sm px-6 py-4 no-print print:hidden">
            <h1 className="text-xl font-semibold text-gray-800">
                Admin Panel
            </h1>

            <button
                onClick={() => setOpen(!open)}
                className="md:hidden text-2xl"
            >
                ☰
            </button>


            <div className="relative" ref={dropdownRef}>
                <button
                    onClick={() => setOpen(!open)}
                    className="w-10 h-10 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold flex items-center justify-center shadow-md hover:scale-105 transition"
                >
                    A
                </button>

                {open && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border p-2 animate-fadeIn">
                        <div className="px-3 py-2 text-sm text-gray-600 border-b">
                            Signed in as <br />
                            <span className="font-semibold text-gray-800">
                                Admin
                            </span>
                        </div>

                        <button
                            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded-lg"
                        >
                            Profile
                        </button>

                        <button
                            onClick={() => dispatch(logout())}
                            className="w-full text-left px-3 py-2 text-sm text-red-500 hover:bg-red-50 rounded-lg"
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}